import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumEstadoOferta } from '../../../oData/enums/enumEstadoOferta'
import { EnumTipoLead } from '../../../oData/enums/enumTipoLead'
import {
  QuoteCommentModel,
  QuoteContractModel,
  QuotePriceModel,
  QuotePriceModelPatch,
  QuotesModel,
  ReEvaluateQuoteRequestModel
} from './model/quotes'

export const apiGetQuotes = async (productId?: number, tollType?: number): Promise<QuotesModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Quotes`, {
    params: {
      productId,
      tollType
    }
  }).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetQuote = async (quoteId: number): Promise<QuotesModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Quotes(${quoteId})`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetLeadQuotes = async (
  leadId: number,
  leadType?: EnumTipoLead
): Promise<QuotesModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Quotes/GetQuotesByLeadId`, {
    params: {
      leadId: leadId,
      leadType: leadType
    }
  }).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetAllLeadQuotes = async (
  leadId: number,
  leadType?: EnumTipoLead
): Promise<QuotesModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59140'
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Quotes/GetAllQuotesByLeadId`, {
    params: {
      leadId: leadId,
      leadType: leadType
    }
  }).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetContractQuotes = async (contractId: number): Promise<QuotesModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Quotes/GetQuotesByContractId`, {
    params: {
      contractId
    }
  }).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPatchQuote = async (
  quoteId: number,
  request: QuotesModel
): Promise<QuotesModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Quotes(${quoteId})`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiPublishQuote = async (quoteId: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Quotes/PublishQuote(${quoteId})`).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiPublishQuoteMassive = async (leadIds: number[]): Promise<number[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Quotes/PublishQuoteMassive`, {
    leadIds
  }).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

// priceList

export const apiGetQuotesPriceList = async (quoteId: number): Promise<QuotePriceModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Quotes(${quoteId})/PriceList`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiPatchQuotePriceList = async (
  quoteId: number,
  priceComponentId: number,
  request: QuotePriceModelPatch
): Promise<QuotePriceModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/Quotes(${quoteId})/PriceList(${priceComponentId})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeactivateQuote = async (
  quoteId: number,
  state: EnumEstadoOferta
): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Quotes(${quoteId})/Deactivate`, state, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteQuote = async (quoteId: number): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59140'

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/Quotes(${quoteId})`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiReEvaluateQuote = async (request: ReEvaluateQuoteRequestModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Quotes/ReEvaluateQuote`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

// QUOTE COMMENTS API //

export const apiGetQuoteComments = async (quoteId: number): Promise<QuoteCommentModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Quotes(${quoteId})/Comments`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiPostQuoteComment = async (
  quoteId: number,
  request: QuoteCommentModel
): Promise<QuoteCommentModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Quotes(${quoteId})/Comments`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiPatchQuoteComment = async (
  quoteId: number,
  quoteCommentId: number,
  request: QuoteCommentModel
): Promise<QuoteCommentModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/Quotes(${quoteId})/Comments(${quoteCommentId})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteQuoteComment = async (
  quoteId: number,
  quoteCommentId: number
): Promise<object> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/Quotes(${quoteId})/Comments(${quoteCommentId})`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

// QUOTE CONTRACTS API //

export const apiPostQuoteContract = async (
  quoteId: number,
  request: QuoteContractModel
): Promise<QuoteContractModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Quotes/${quoteId}/Contracts`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiPatchQuoteContract = async (
  quoteId: number,
  quoteContractId: number,
  request: QuoteContractModel
): Promise<QuoteContractModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/Quotes/${quoteId}/Contracts/${quoteContractId}`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteQuoteContract = async (
  quoteId: number,
  quoteContractId: number
): Promise<object> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/Quotes/${quoteId}/Contracts/${quoteContractId}`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}
